import React, { useState } from "react";
import DoneIcon from "@mui/icons-material/Done";
import ClearIcon from "@mui/icons-material/Clear";

// import JS files
// import { defaultRingSize, reverseShowNums } from "../../constants/constants";
import MuiTextField from "./MuiTextField";
import { useSetting } from "../../context/SettingContext";

const OrderCardLeftPartTemplate = (props) => {
  const { defaultRingSize, reverseShowNums } = useSetting();

  const check_admin_and_user_value = (index) => {
    if (index == 0) {
      return (
        props.data_item.size_one_num === props.data_item.admin_size_one_num
      );
    } else if (index == 1) {
      return (
        props.data_item.size_two_num === props.data_item.admin_size_two_num
      );
    } else if (index == 2) {
      return (
        props.data_item.size_three_num === props.data_item.admin_size_three_num
      );
    } else if (index == 3) {
      return (
        props.data_item.size_four_num === props.data_item.admin_size_four_num
      );
    } else if (index == 4) {
      return (
        props.data_item.size_five_num === props.data_item.admin_size_five_num
      );
    } else if (index == 5) {
      return (
        props.data_item.size_six_num === props.data_item.admin_size_six_num
      );
    }
  };

  const get_value_item = (index, type) => {
    if (index == 0) {
      if (type == "admin") return props.data_item.admin_size_one_num;
      return props.data_item.size_one_num;
    } else if (index == 1) {
      if (type == "admin") return props.data_item.admin_size_two_num;

      return props.data_item.size_two_num;
    } else if (index == 2) {
      if (type == "admin") return props.data_item.admin_size_three_num;

      return props.data_item.size_three_num;
    } else if (index == 3) {
      if (type == "admin") return props.data_item.admin_size_four_num;

      return props.data_item.size_four_num;
    } else if (index == 4) {
      if (type == "admin") return props.data_item.admin_size_five_num;

      return props.data_item.size_five_num;
    } else if (index == 5) {
      if (type == "admin") return props.data_item.admin_size_six_num;

      return props.data_item.size_six_num;
    }
  };
console.log(props.data_item)
  const get_default_value_item_for_show_accept_number = (index, type) => {
    // console.log('admin hossein',props.data_item)
    if (index == 0) {
      if (type == "admin") return props.data_item[0];
      return props.data_item.size_one_num;
    } else if (index == 1) {
      if (type == "admin") return props.data_item[1];

      return props.data_item.size_two_num;
    } else if (index == 2) {
      if (type == "admin") return props.data_item[2];

      return props.data_item.size_three_num;
    } else if (index == 3) {
      if (type == "admin") return props.data_item[3];

      return props.data_item.size_four_num;
    } else if (index == 4) {
      if (type == "admin") return props.data_item[4];

      return props.data_item.size_five_num;
    } else if (index == 5) {
      if (type == "admin") return props.data_item[5];

      return props.data_item.size_six_num;
    }
  };

  const admin_get_remain_user_value_item = (index, type) => {
    console.log("here for remain ");
    if (index == 0) {
      if (type == "admin") {
        if (props.data_item.admin_change_item) {
          if (
            props.data_item.size_one_num - props.data_item.admin_size_one_num >
            0
          )
            return (
              props.data_item.size_one_num - props.data_item.admin_size_one_num
            );
          else return 0;
        } else {
          console.log("else of for remain ");

          return props.data_item.admin_size_one_num;
        }
      }

      return props.data_item.size_one_num;
    } else if (index == 1) {
      if (type == "admin") {
        if (props.data_item.admin_change_item) {
          if (
            props.data_item.size_two_num - props.data_item.admin_size_two_num >
            0
          )
            return (
              props.data_item.size_two_num - props.data_item.admin_size_two_num
            );
          else return 0;
        } else {
          return props.data_item.admin_size_two_num;
        }
      }
      return props.data_item.size_two_num;
    } else if (index == 2) {
      if (type == "admin") {
        if (props.data_item.admin_change_item) {
          if (
            props.data_item.size_three_num -
              props.data_item.admin_size_three_num >
            0
          )
            return (
              props.data_item.size_three_num -
              props.data_item.admin_size_three_num
            );
          else return 0;
        } else {
          return props.data_item.admin_size_three_num;
        }
      }
      return props.data_item.size_three_num;
    } else if (index == 3) {
      // if (type == "admin") return props.data_item.admin_size_four_num;

      if (type == "admin") {
        if (props.data_item.admin_change_item) {
          if (
            props.data_item.size_four_num -
              props.data_item.admin_size_four_num >
            0
          )
            return (
              props.data_item.size_four_num -
              props.data_item.admin_size_four_num
            );
          else return 0;
        } else {
          return props.data_item.admin_size_four_num;
        }
      }

      return props.data_item.size_four_num;
    } else if (index == 4) {
      // if (type == "admin") return props.data_item.admin_size_five_num;

      if (type == "admin") {
        if (props.data_item.admin_change_item) {
          if (
            props.data_item.size_five_num -
              props.data_item.admin_size_five_num >
            0
          )
            return (
              props.data_item.size_five_num -
              props.data_item.admin_size_five_num
            );
          else return 0;
        } else {
          return props.data_item.admin_size_five_num;
        }
      }

      return props.data_item.size_five_num;
    } else if (index == 5) {
      // if (type == "admin") return props.data_item.admin_size_six_num;

      if (type == "admin") {
        if (props.data_item.admin_change_item) {
          if (
            props.data_item.size_six_num - props.data_item.admin_size_six_num >
            0
          )
            return (
              props.data_item.size_six_num - props.data_item.admin_size_six_num
            );
          else return 0;
        } else {
          return props.data_item.admin_size_six_num;
        }
      }

      return props.data_item.size_six_num;
    }
  };

  const get_value_color = (index, type) => {
    if (index == 0) {
      if (props.data_item.admin_change_item) {
        if (
          props.data_item.size_one_num - props.data_item.admin_size_one_num <=
          0
        )
          return "1px solid green";
        return "1px solid red";
      }
      return "";
    } else if (index == 1) {
      if (props.data_item.admin_change_item) {
        if (
          props.data_item.size_two_num - props.data_item.admin_size_two_num <=
          0
        )
          return "1px solid green";
        return "1px solid red";
      }
      return "";
    } else if (index == 2) {
      if (props.data_item.admin_change_item) {
        if (
          props.data_item.size_three_num -
            props.data_item.admin_size_three_num <=
          0
        )
          return "1px solid green";
        return "1px solid red";
      }
      return "";
    } else if (index == 3) {
      if (props.data_item.admin_change_item) {
        if (
          props.data_item.size_four_num - props.data_item.admin_size_four_num <=
          0
        )
          return "1px solid green";
        return "1px solid red";
      }
      return "";
    } else if (index == 4) {
      if (props.data_item.admin_change_item) {
        if (
          props.data_item.size_five_num - props.data_item.admin_size_five_num <=
          0
        )
          return "1px solid green";
        return "1px solid red";
      }
      return "";
    } else if (index == 5) {
      if (props.data_item.admin_change_item) {
        if (
          props.data_item.size_six_num - props.data_item.admin_size_six_num <=
          0
        )
          return "1px solid green";
        return "1px solid red";
      }
      return "";
    }
  };

  return (
    <>
      {props.adminDidntNeedCustomerRequestNum !== true && (
        <div className="grid grid-cols-1 md:grid-cols-7">
          <div className="col-span-1">
            <p className=" text-center text-xs md:text-sm py-3">درخواستی:</p>
          </div>
          <div className="col-span-6 grid grid-cols-3 md:grid-cols-6 gap-2">
            {props.nums.map((item, index) => {
              return [
                <>
                  <div>
                    <MuiTextField
                      onChange={(e) =>
                        props.update_nums(
                          props.ringId,
                          reverseShowNums ? defaultRingSize - index : index,
                          e.target.value
                        )
                      }
                      id="outlined-basic"
                      variant="outlined"
                      size="small"
                      defaultValue={
                        props.showAcceptedRing
                          ? get_value_item(
                              reverseShowNums ? defaultRingSize - index : index,
                              "admin"
                            )
                          : get_value_item(
                              reverseShowNums ? defaultRingSize - index : index
                            )
                      }
                      isLTR={true}
                      disabled={props.customerCanEdit ? false : true}
                      tabIndex={`${
                        reverseShowNums
                          ? defaultRingSize - index
                          : index + 1 + props.random_num
                      }`}
                      autoFocus={
                        props.autoFocusFalse
                          ? false
                          : reverseShowNums
                          ? defaultRingSize + 1 - index
                          : index == 0
                          ? true
                          : false
                      }
                    />
                  </div>
                </>,
              ];
            })}
          </div>
        </div>
      )}
      {props.DontShowAcceptItem ? (
        <></>
      ) : !props.order_item_is_active ? (
        <>
          <div className="grid grid-cols-1 md:grid-cols-7">
            <div className="col-span-1">
              <p className=" text-center text-xs md:text-sm py-3">پذیرش:</p>
            </div>
            <div className="col-span-6 grid grid-cols-3 md:grid-cols-6 gap-2">
              {props.nums.map((item, index) => {
                return [
                  <>
                    <div>
                      <MuiTextField
                        onChange={(e) =>
                          props.update_nums(
                            props.ringId,
                            reverseShowNums ? defaultRingSize - index : index,
                            e.target.value
                          )
                        }
                        id="outlined-basic"
                        variant="outlined"
                        size="small"
                        isLTR={true}
                        defaultValue={
                          props.adminNeedRemainUSerValues
                            ? admin_get_remain_user_value_item(
                                reverseShowNums
                                  ? defaultRingSize - index
                                  : index,
                                "admin"
                              )
                            : get_value_item(
                                reverseShowNums
                                  ? defaultRingSize - index
                                  : index,
                                "admin"
                              )
                        }
                        disabled={props.adminCantEdit ? true : false}
                        color={
                          props.adminNeedColor
                            ? get_value_color(
                                reverseShowNums
                                  ? defaultRingSize - index
                                  : index
                              )
                            : ""
                        }
                      />
                    </div>
                  </>,
                ];
              })}
            </div>
          </div>
        </>
      ) : (
        ""
      )}
      {props.showReturnNumber ? (
        <>
          <div className="grid grid-cols-1 md:grid-cols-7">
            <div className="col-span-1">
              <p className=" text-center text-xs md:text-sm py-3">مرجوعی:</p>
            </div>
            <div className="col-span-6 grid grid-cols-3 md:grid-cols-6 gap-2">
              {props.nums.map((item, index) => {
                return [
                  <>
                    <div>
                      <MuiTextField
                        onChange={(e) =>
                          props.update_nums(
                            props.ringId,
                            reverseShowNums ? defaultRingSize - index : index,
                            e.target.value
                          )
                        }
                        id="outlined-basic"
                        variant="outlined"
                        size="small"
                        isLTR={true}
                        defaultValue="0"
                        disabled={props.adminCantEdit ? true : false}
                        color={
                          props.adminNeedColor
                            ? get_value_color(
                                reverseShowNums
                                  ? defaultRingSize - index
                                  : index
                              )
                            : ""
                        }
                      />
                    </div>
                  </>,
                ];
              })}
            </div>
          </div>
        </>
      ) : (
        ""
      )}
      {props.showAcceptNumber ? (
        <>
          <div className="grid grid-cols-1 md:grid-cols-7">
            <div className="col-span-1">
              <p className=" text-center text-xs md:text-sm py-3">تحویلی:</p>
            </div>
            <div className="col-span-6 grid grid-cols-3 md:grid-cols-6 gap-2">
              {props.nums.map((item, index) => {
                return [
                  <>
                    <div>
                      <MuiTextField
                        onChange={(e) =>
                          props.update_nums(
                            props.ringId,
                            reverseShowNums ? defaultRingSize - index : index,
                            e.target.value
                          )
                        }
                        id="outlined-basic"
                        variant="outlined"
                        size="small"
                        isLTR={true}
                        defaultValue={
                          props.adminNeedShowAcceptNumberDefaults
                            ? get_default_value_item_for_show_accept_number(
                                reverseShowNums
                                  ? defaultRingSize - index
                                  : index,
                                "admin"
                              )
                            : "0"
                        }
                        disabled={props.adminCantEdit ? true : false}
                        color={
                          props.adminNeedColor
                            ? get_value_color(
                                reverseShowNums
                                  ? defaultRingSize - index
                                  : index
                              )
                            : ""
                        }
                      />
                    </div>
                  </>,
                ];
              })}
            </div>
          </div>
        </>
      ) : (
        ""
      )}
      {/* {props.showAcceptOrRejectFromAdmin ? (
        <>
          <div className="grid grid-cols-1 md:grid-cols-7 items-center ">
            <div className="col-span-1">
              <p className=" text-center text-xs md:text-sm py-3">مغایرت:</p>
            </div>
            <div className="col-span-6 grid grid-cols-3 md:grid-cols-6 gap-2">
              {props.nums.map((item, index) => {
                return [
                  <>
                    {check_admin_and_user_value(index) ? (
                      <div className="text-center">
                        <DoneIcon className="text-green-500" />
                      </div>
                    ) : (
                      <div className="text-center">
                        <ClearIcon className="text-red-500" />
                      </div>
                    )}
                  </>,
                ];
              })}
            </div>
          </div>
        </>
      ) : undefined} */}
    </>
  );
};

export default OrderCardLeftPartTemplate;
